export default "__VITE_ASSET__CVSIeVOo__"